import { render } from "./Lagoon.vue?vue&type=template&id=18de7e5b&scoped=true"
import script from "./Lagoon.vue?vue&type=script&lang=js"
export * from "./Lagoon.vue?vue&type=script&lang=js"

import "./Lagoon.vue?vue&type=style&index=0&id=18de7e5b&scoped=true&lang=css"

import exportComponent from "/Users/pongsakornsomsri/workspace/neera-retreat-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18de7e5b"]])

export default __exports__